import type { Card, ScoreResult } from './types';

export function computeScore(collectionCards: Card[]): ScoreResult {
  const items: ScoreResult['items'] = [];

  const tenDiamonds = collectionCards.find((card) => card.rank === '10' && card.suit === 'D');
  if (tenDiamonds) {
    items.push({
      ruleId: 'TEN_DIAMONDS',
      label: '10♦',
      points: 2,
      cards: [tenDiamonds],
    });
  }

  const aces = collectionCards.filter((card) => card.rank === 'A');
  if (aces.length > 0) {
    items.push({
      ruleId: 'ACES',
      label: `Aces x${aces.length}`,
      points: aces.length,
      cards: aces,
      counts: { aces: aces.length },
    });
  }

  const twoSpades = collectionCards.find((card) => card.rank === '2' && card.suit === 'S');
  const hasBonusTrigger = Boolean(tenDiamonds || aces.length > 0);
  if (twoSpades) {
    const triggerCards = [...aces];
    if (tenDiamonds) {
      triggerCards.push(tenDiamonds);
    }
    if (triggerCards.length > 0) {
      items.push({
        ruleId: 'TWO_SPADES',
        label: '2♠ bonus',
        points: 1,
        cards: [twoSpades],
        dependency: 'Requires Ace or 10♦',
      });
    }
  }

  const spadeCards = collectionCards.filter((card) => card.suit === 'S');
  if (spadeCards.length >= 7 && hasBonusTrigger) {
    items.push({
      ruleId: 'SEVEN_SPADES',
      label: '7 Spades bonus',
      points: 1,
      cards: spadeCards,
      counts: { spades: spadeCards.length },
      dependency: 'Requires Ace or 10♦',
    });
  }

  if (collectionCards.length >= 26 && hasBonusTrigger) {
    items.push({
      ruleId: 'TWENTY_SIX_CARDS',
      label: '26 Cards bonus',
      points: 1,
      counts: { totalCards: collectionCards.length },
      dependency: 'Requires Ace or 10♦',
    });
  }

  const total = items.reduce((sum, item) => sum + item.points, 0);
  return { total, items };
}
